import React from "react"
import {
    AddOnsSelector,
    componentStyles,
} from "@mallardbay/lib-react-components"

import type {
    ListingFieldsFragment,
    PricingPackageFieldsFragment,
} from "~graphql/generated/graphql"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import { onQuantityChange } from "~components/pages/listing/checkout/add-ons/extra-add-ons-helpers"
import useExtraAddOnsForListingAndPricingPackage from "~utils/use-extra-add-ons-for-listing-and-pricing-package"
import COPY from "~config/copy-constants"

interface Props {
    readonly listing: ListingFieldsFragment
    readonly pricingPackage: PricingPackageFieldsFragment
}

export default function ExtraAddOns({ listing, pricingPackage }: Props) {
    const styles = useStyles()

    const { packageState, updatePackageState } = useCheckoutFlow()
    const { addOns } = useExtraAddOnsForListingAndPricingPackage({
        listingId: listing.id,
        pricingPackageId: pricingPackage.id,
    })

    return (
        <AddOnsSelector
            style={styles.addOnsSelector}
            addOns={addOns}
            selectedAddOns={packageState.add_ons ?? []}
            onQuantityChange={({ addOn, quantity }) =>
                onQuantityChange({
                    addOn,
                    quantity,
                    packageState,
                    updatePackageState,
                })
            }
            addButtonLabel={COPY.ADD_TO_CART}
            updateButtonLabel={COPY.UPDATE_CART}
        />
    )
}

function useStyles() {
    return componentStyles({
        addOnsSelector: {
            marginTop: 6,
            marginBottom: 6,
        },
    })
}
